type PathArgs = {
  sessionId: string
}

export const routes = {
  step: {
    root: {
      getPath: ({ sessionId }: PathArgs) => `/session/${sessionId}/` as const,
    },

    additionalInfoIntro: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/additional-info-intro/` as const,
    },

    bankId: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/bank-id/` as const,
    },

    mObywatel: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/mobywatel/` as const,
    },

    identityVerificationManualIdInfo: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/identity-verification-manual-id-info/` as const,
    },

    internationalAddress: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/international-address/` as const,
    },

    czBasicAccountAgreements: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/cz-basic-account-agreements/` as const,
    },

    plBasicAccountAgreements: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pl-basic-account-agreements/` as const,
    },

    premiumAccountAgreements: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/premium-account-agreements/` as const,
    },

    emailPrivacyPolicy: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/email-privacy-policy/` as const,
    },

    expenses: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/expenses/` as const,
    },

    accountExists: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/account-exists/` as const,
    },

    accountExistsWithoutPassword: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/account-exists-without-password/` as const,
    },

    bankConnectionIntro: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/bank-connection-intro/` as const,
    },

    password: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/password/` as const,
    },

    name: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/name/` as const,
    },

    otpVerificationEmail: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/otp-verification-email/` as const,
    },

    otpVerificationSms: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/otp-verification-sms/` as const,
    },

    phoneNumber: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/phone-number/` as const,
    },

    personalId: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/personal-id/` as const,
    },

    educationType: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/education-type/` as const,
    },

    familyChildren: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/family-children/` as const,
    },

    familyStatus: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/family-status/` as const,
    },

    generalError: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/general-error/` as const,
    },

    incomeType: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-type/` as const,
    },

    housingType: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/housing-type/` as const,
    },

    housingExpenditureStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/housing-expenditure/` as const,
    },

    otherExpenditureStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/other-expenditure/` as const,
    },

    employmentType: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/employment-type/` as const,
    },

    income: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income/` as const,
    },

    identityVerificationIntro: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/identity-verification-intro/` as const,
    },

    identityVerificationRetry: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/identity-verification-retry/` as const,
    },

    countryOfBirth: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/birth-country/` as const,
    },

    bankConnectionSuccess: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/bank-connection-success/` as const,
    },

    reviewIncome: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/review-income/` as const,
    },

    startingOffer: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/starting-offer/` as const,
    },

    finalOffer: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/final-offer/` as const,
    },

    finalOfferRevolvingOnly: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/final-offer-revolving-only/` as const,
    },

    finalSummary: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/final-summary/` as const,
    },

    loanRepayment: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/loan-repayments/` as const,
    },

    riskCheckProcessing: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/risk-check-processing/` as const,
    },

    processing: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/processing/` as const,
    },

    riskApproved: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/risk-approved/` as const,
    },

    redirect: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/redirect/` as const,
    },

    riskManualReviewStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/risk-manual-review/` as const,
    },

    onboardingRejected: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/onboarding-rejected/` as const,
    },

    onboardingCompleted: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/onboarding-completed/` as const,
    },

    onboardingPlanPromo: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/onboarding-plan/` as const,
    },

    onboardingError: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/onboarding-error/` as const,
    },

    crossCheckWarning: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/cross-check-warning/` as const,
    },

    incomeVerificationIntro: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verification-intro/` as const,
    },

    incomeVerificationCompleted: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verification-completed/` as const,
    },

    incomeVerificationBankAccountConnectionError: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verification-bank-account-connection-error/` as const,
    },

    incomeVerificationBankAccountConnectionTooLong: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verification-bank-account-connection-too-long/` as const,
    },

    incomeVerificationBankAccountConnectionWarning: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verification-bank-account-connection-warning/` as const,
    },

    consentCollection: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/consent-collection/` as const,
    },

    consentCollectionCompleted: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/consent-collection-completed/` as const,
    },

    // income-verify for the Kontomatik steps
    incomeVerifyIntroStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-intro/` as const,
    },

    kontomatikPendingResultStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-pending/` as const,
    },
    kontomatikTimeoutStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-timeout/` as const,
    },
    kontomatikSuccessStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-success/` as const,
    },
    kontomatikNoIncomeStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-no-income/` as const,
    },
    kontomatikLowIncomeStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-low-income/` as const,
    },
    psd2MandatoryPromptStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/psd2-mandatory-prompt-step/` as const,
    },
    kontomatikRedirectStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/kontomatik-redirect-step/` as const,
    },
    kontomatikRetryPromptStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/kontomatik-retry-prompt-step/` as const,
    },
    transientErrorStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/transient-error-step/` as const,
    },
    startingOfferLowerIncomeStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-starting-offer-lower-income/` as const,
    },
    kontomatikErrorStep: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/income-verify-error/` as const,
    },

    // Pay in N steps
    payInNPreSelectedPlans: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/pre-selected-plans/` as const,
    },

    payInNPlanChoice: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/plan-choice/` as const,
    },

    payInNEmailCheck: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/email-check/` as const,
    },

    payInNInstallmentCalculator: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/installment-calculator/` as const,
    },

    payInNInstallmentCalculatorConfirmation: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/plan-confirmation/` as const,
    },

    payInNSecurityCodeSetup: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/security-code-setup/` as const,
    },

    payInNSecurityCode: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/security-code/` as const,
    },

    payInNOtpVerificationSms: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/otp-verification-sms/` as const,
    },

    payInNDocuments: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/documents/` as const,
    },

    payInNDocumentsConfirmation: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/documents-confirmation/` as const,
    },

    payInNDownpayment: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/downpayment/` as const,
    },

    payInNCompleted: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/completed/` as const,
    },

    payInNDeclined: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/declined/` as const,
    },

    payInNRejected: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/rejected/` as const,
    },

    payInNScoring: {
      getPath: ({ sessionId }: PathArgs) =>
        `/session/${sessionId}/pay-in-n/scoring/` as const,
    },
  },
} as const
